import BaseField from './BaseField';
import $ from 'cash-dom';
import UrlHelper from '../../../../components/UrlHelper';

class DropdownField extends BaseField {
	constructor($input) {
		super($input);

		this._$input.on('change', this._changeHandler);
	}

	_getLabel() {
		return this._$input.find('.select-label').text().trim();
	}

	getValue() {
		return this._$input.val();
	}

	setValueAndTriggerEvent(filterValue) {
		this.setValue(filterValue);
		// no need to trigger some event, because setValue() sets needed select option,
		// which will trigger the select change event
	}

	setValue(filterValue) {
		this._$input.find('.option[value="' + filterValue + '"]').trigger('click');
	}

	getVendors() {
		return this._getSelectedOption().data('vendors');
	}

	_getDeeplinks() {
		return this._getSelectedOption().data('deeplinks');
	}

	_getSelectedOption() {
		return this._$input.find('.option[value="' + this._$input.val() + '"]');
	}

	getAllOptionsValues() {
		const optionsValues = [];

		this._$input.find('.option').each((i, option) => {
			const $option = $(option);

			optionsValues.push($option.attr('value'))
		});

		return optionsValues;
	}

	_changeHandler = (e) => {
		const $currentSelect = $(e.currentTarget);

		const redirectLink = this._getSelectedOption($currentSelect).data('link');

		if (redirectLink) {
			this._isLinkTheSameAsCurrentUrl = UrlHelper.isLinkTheSameAsCurrentUrl(redirectLink);

			$(document).trigger(BaseField.EVENT_FILTER_FIELD_CHANGE, {
				redirectLink,
				filterName: $currentSelect.attr('name'),
				currentFieldValue: this.getValue(),
			});
			return;
		} else {
			this._isLinkTheSameAsCurrentUrl = false;
		}

		$(document).trigger(BaseField.EVENT_FILTER_FIELD_CHANGE, {
			filterName: $currentSelect.attr('name'),
			currentFieldValue: this.getValue(),
		});
	}

	getRedirectLinkForValue(filterValue) {
		return this._$input.find(`[value= "${filterValue}"]`).data('link');
	}

	getVendorsWithOrder() {
		return this._getSelectedOption().data('vendors-with-order');
	}

	getShowVisiblyHiddenVendor() {
		return !!this._getSelectedOption().data('show-visibly-hidden-vendor');
	}

	isWithVisiblyHiddenSplit() {
		return !!this._$input.data('is-with-visibly-hidden-split');
	}
}

export default DropdownField;
